export const SCRATCH_CARD_VARIANTS = {
  SCRATCH_CARD: 'scratch-card',
  LEVEL_UP: 'level-up',
  STATUS_UP: 'status-up',
} as const;

export type ScratchCardVariant = typeof SCRATCH_CARD_VARIANTS[keyof typeof SCRATCH_CARD_VARIANTS];

export const isScratchCardVariant = (value: unknown): value is ScratchCardVariant => {
  return value === SCRATCH_CARD_VARIANTS.SCRATCH_CARD || value === SCRATCH_CARD_VARIANTS.LEVEL_UP || value === SCRATCH_CARD_VARIANTS.STATUS_UP;
};
